import { fromJS, Record } from 'immutable';
import {
  generateKeys,
  generateSchema,
} from '../../../utils/helpers/model.helper';

export const TOTAL_PER_CLIENT_FILTER_SCHEMA = Object.freeze({
  ID: '',
  NAME: '',
  DURATION: 0,
});
const RECORD = generateSchema(TOTAL_PER_CLIENT_FILTER_SCHEMA);
const KEYS: any = generateKeys(TOTAL_PER_CLIENT_FILTER_SCHEMA);

export class TotalPerClientFilter extends Record(RECORD) {
  static KEYS: any = KEYS;

  constructor(props?: any) {
    super(props && props.toMap ? props.toMap() : fromJS(props || {}));
  }

  get id(): string {
    return this.get(KEYS.ID);
  }

  get name(): string {
    return this.get(KEYS.NAME);
  }

  get duration(): number {
    return this.get(KEYS.DURATION);
  }
}
